<template>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-12 pt-3 pb-3 pl-4">
          <h3><i class="fas fa-id-badge"></i> Cadastro de Usuario Totem</h3>
        </div>
      </div>
      <TotemAdd v-if="showAdd" ref="TotemAdd" v-on:Back="onBack" />
      <TotemList v-else ref="TotemList" v-on:New="onNew" v-on:Edit="onEdit"/>
    </div>
  </template>
<script>
import Tools from '@/components/tools/Tools.js'
import TotemAdd from './components/add/totemAdd.vue'
import TotemList from './components/list/totemList.vue'

export default {
  name: 'UsuarioSenhas',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    TotemAdd,
    TotemList
  },
  mounted () { },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.TotemAdd.onEdit(obj)
      })
    },
    onNew () {
      this.showAdd = true
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/nxSenhas/totem/totem.vue